import * as React from "react";
import { getDictPhrase } from "../../../../helpers";
export const GameState = (props) => {
    return (props.details.event.isLive
        ? React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__game-state`, "data-uat": `div-ev-list-${props.componentPrefix}-game-state` },
            React.createElement("span", { className: `rj-ev-list__${props.componentPrefix}__game-part`, "data-uat": `span-ev-list-${props.componentPrefix}-game-state-part` }, getDictPhrase(props.details.dict, props.details.event.gamePart)),
            React.createElement("span", { className: `rj-ev-list__${props.componentPrefix}__game-time`, "data-uat": `span-ev-list-${props.componentPrefix}-game-state-time` }, props.details.event.gameTime
                ? props.details.dict.ClockMins.format(props.details.event.gameTime)
                : ""))
        : React.createElement(React.Fragment, null));
};
//# sourceMappingURL=GameState.js.map